import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getSingle, updateSingle } from "../../services/bankService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";

class BankEditForm extends Form {
  state = {
    data: {
      name: "",
      address: "",
      phone: "",
      account: "",
    },
    errors: {},
  };

  schema = {
    visa_id: Joi.number().label("Visa Account"),
    name: Joi.string().required().label("Account"),
    address: Joi.string().required().label("Address"),
    phone: Joi.string().required().label("Phone"),
    account: Joi.string().required().label("Account"),
    account_title: Joi.string().required().label("Account Title"),
    iban: Joi.string().required().label("IBAN"),
    branch_name: Joi.string().required().label("Branch Name"),
    branch_code: Joi.string().required().label("Branch Code"),
  };

  async populateAccount() {
    try {
      const accountId = this.props.match.params.id;

      this.setState({ blocking: true });
      const { data: account } = await getSingle(accountId);

      this.setState({ blocking: false });
      this.setState({ data: this.mapToViewModel(account) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateAccount();
  }

  mapToViewModel(account) {
    return {
      name: account.name,
      address: account.address,
      phone: account.phone,
      account: account.account,
      account_title: account.account_title,
      iban: account.iban,
      branch_name: account.branch_name,
      branch_code: account.branch_code,
    };
  }

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      const data = { ...this.state.data };
      data.id = parseInt(ledgerTypeId);
      this.setState({ blocking: true });
      await updateSingle(data);
      this.setState({ blocking: false });
      toast.success("Account has been updated successfully.");
      this.props.history.push("/banks-accounts");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.address)
          errors.address = ex.response.data.errors.address;

        if (ex.response.data.errors.phone)
          errors.phone = ex.response.data.errors.phone;

        if (ex.response.data.errors.account)
          errors.account = ex.response.data.errors.account;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/bank.png";
    // if (auth.getCurrentUser().email != "company-unblocker@gondalgroup.ae") {
    //   return "Your are authorized to perform this action.";
    // }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update bank acount</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/banks-accounts")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update bank acount</h3>
              <p>Provide the information below to update the bank account.</p>
              {this.renderInput("name", "Bank Name", "text")}
              {this.renderInput("address", "Address", "text")}
              {this.renderInput("phone", "Phone", "text")}
              {this.renderInput("account", "Account Number", "text")}
              {this.renderInput("account_title", "Account Title", "text")}
              {this.renderInput("iban", "IBAN", "text")}
              {this.renderInput("branch_name", "Branch Name", "text")}
              {this.renderInput("branch_code", "Branch Code", "text")}

              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default BankEditForm;
